// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.itasidebar-inline-1 {
  object-fit: contain;
  background: #fff;
}

.itasidebar-inline-2 {
  color: #fff;
  font-family: 'Outfit',sans-serif;
  font-weight: 700;
  font-size: 15px;
}

.itasidebar-inline-3 {
  color: #94a3b8;
  font-size: 9.5px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.itasidebar-inline-4 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
}

.itasidebar-inline-5 {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: linear-gradient(135deg,#2563eb,#60a5fa);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  font-size: 12px;
  font-family: 'Outfit',sans-serif;
}

.itasidebar-inline-6 {
  color: #e2e8f0;
  font-size: 12px;
  font-weight: 600;
}

.itasidebar-inline-7 {
  color: #94a3b8;
  font-size: 10px;
}

.itasidebar-inline-8 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  color: rgba(239,68,68,.8);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  background: transparent;
  width: 100%;
  margin-top: 4px;
  font-family: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/ITAdmin/ITASidebar.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mDAAmD;EACnD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB","sourcesContent":[".itasidebar-inline-1 {\n  object-fit: contain;\n  background: #fff;\n}\n\n.itasidebar-inline-2 {\n  color: #fff;\n  font-family: 'Outfit',sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n}\n\n.itasidebar-inline-3 {\n  color: #94a3b8;\n  font-size: 9.5px;\n  font-weight: 600;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.itasidebar-inline-4 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n}\n\n.itasidebar-inline-5 {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  background: linear-gradient(135deg,#2563eb,#60a5fa);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-weight: 700;\n  font-size: 12px;\n  font-family: 'Outfit',sans-serif;\n}\n\n.itasidebar-inline-6 {\n  color: #e2e8f0;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.itasidebar-inline-7 {\n  color: #94a3b8;\n  font-size: 10px;\n}\n\n.itasidebar-inline-8 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  color: rgba(239,68,68,.8);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  width: 100%;\n  margin-top: 4px;\n  font-family: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
